<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div class="information">
          <h3>M205 授權查調財產資料查詢</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td width="15%" style="text-align: right">年度：</td>
                  <td width="35%" style="text-align: left">
                    <select v-model="form.syear" @change="syearChange()">
                      <option value="" selected disabled hidden>請選擇</option>
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                  <td width="15%" style="text-align: right">查調日期：</td>
                  <td width="35%" style="text-align: left">
                    <select
                      v-model="form.authOpenDate"
                      :disabled="form.syear == '' || form.syear == null"
                    >
                      <option value="" selected disabled hidden>請選擇</option>
                      <option
                        v-for="(data, index) in dropDownList.authOpenDates"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號：</td>
                  <td>
                    <input
                      type="text"
                      maxlength="10"
                      v-model="form.idn"
                    />
                  </td>
                  <td>姓名：</td>
                  <td>
                    <input
                      type="text"
                      maxlength="10"
                      v-model="form.name"
                    />
                  </td>
                </tr>
                 <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="() => { this.form.currentpage = 1; this.form.pagesize = 10; this.doQuery()}"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="doClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%" v-if="grid && grid.gridDatas">
            <tbody>
              <tr>
                <td v-if="grid.paginaiton" align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>操作</th>
                  <th>姓名</th>
                  <th>身分證統一編號</th>
                  <th>申報日期</th>
                  <th>申報表名稱</th>
                </tr>
              </thead>
              <tbody v-if="grid && grid.gridDatas && grid.gridDatas.length">
                <tr v-for="(data, index) in grid.gridDatas" :key="index">
                  <td width="1%" align="center">
                    <input type="button" class="btn" value="列印" @click="doPrint(data)" />
                  </td>
                  <td>{{ data.familyname }}</td>
                  <td>{{ data.familyidn }}</td>
                  <td>{{ data.surveyday }}</td>
                  <td>{{ data.protypename }}</td>
                </tr>
              </tbody>
              <tbody v-else-if="Object.keys(grid).length !== 0">
                <tr>
                  <td colspan="5" style="text-align: center;">查無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </div>
    <Alert v-model="Alert.show" :title="Alert.title" :ServiceUnit="pageData.ServiceUnit">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.show = false">確定</button>
        </div>
      </div>
    </Alert>
    <CyFooter />
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import { PrintReport,M205_SearchGrid,M104_SearchDropDown } from "@/service/api.js";
import { getMenuIndex } from "@/config/util.js";
export default {
  name: "M205",
  data: function () {
    return {
      pageData: {
        MenuIndex: 2,
        PrgName: "M205",
        ServiceUnit: "CY",
        isForceLoginOut : true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        syear: "",
        authOpenDate: "",
        idn: "",
        name: "",
        currentpage: 1,
        pagesize: 10,
      },
      dropDownList: {
        syears: [],
        authOpenDates: [],
      },
      grid: {},
      Alert:{
        show:false,
        title:"",
        txt:"",
      }
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [""];
      for (
        let i = new Date().getFullYear() - 1911;
        i > new Date().getFullYear() - 1911 - 10;
        i--
      ) {
        syears.push(i.toString());
      }
      return syears;
    },
    syearChange: function () {
      const self = this;
      self.dropDownList.authOpenDates = [];
      self.form.authOpenDate = "";
      let data = {
        serviceUnit: this.pageData.ServiceUnit,
        syear: this.form.syear,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "下拉查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      M104_SearchDropDown(data).then((rData) => {
        if (rData.returnObject != null) {
          self.dropDownList.authOpenDates = rData.returnObject.map(
            (x) => x.authOpenDate
          );
        }
      });
    },
    doQuery: function () {
      const self = this;
      if(!self.checkPage(self.form.currentpage , self.form.pagesize)) return;
      if(self.form.syear == "")
      {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請輸入申報年度"];
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return;
      }
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        SYEAR: self.form.syear,
        authOpenDate: self.form.authOpenDate,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo:{
            Id:self.loginInfo.id,
            PrgCode:self.pageData.PrgName,
            ActCd:"查詢",
            ServiceUnit:self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          }
      };
      M205_SearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        }
        console.log(rData.messages);
      });
    },
    //分頁防呆檢查
    checkPage: function(currentpage,pagesize){
      const self = this;
      let pageErrorMsg = [];
      if(currentpage){
        if(isNaN(parseInt(currentpage))){
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if(pagesize){
        if(isNaN(parseInt(pagesize))){
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if(pageErrorMsg.length){
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    doClear: function () {
      this.form = {
        syear: "",
        idn: "",
        name: "",
        currentpage: 1,
        pagesize: 10,
      };
    },
    doPrint: function (data) {
      const self = this;
      let postData = {
        serviceUnit: 'CY',
        seqno: data.auth_SEQ,
        printType: "A",
        proType: data.protype,
        id:self.loginInfo.id,
      };
      PrintReport(postData).then(rData => {
        var link = document.createElement("a");
        link.download =
            new Date().toISOString().slice(0, 10).replace(/-/g, "") +
            "公職人員授權查調財產申報表";
        link.href = "data:application/pdf;base64," + rData;
        link.click();
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    self.pageData.MenuIndex = getMenuIndex(self.pageData.PrgName);
    if (self.pageData.MenuIndex === null) {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    //self.doQuery();
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />
